(function () {
  'use strict';

  /* ── GLOBAL EXCLUSIVE ACCORDION ──
     Finds the nearest ancestor that
     contains more than one <details>
     element and treats them as a group.
     Works whether <details> are direct
     siblings OR each wrapped in their
     own div (as in Dawn's main-product).
  ── */

  function getGroup(detail) {
    var el = detail.parentElement;
    var maxLevels = 6;
    var level = 0;

    while (el && el !== document.body
           && level < maxLevels) {
      var found = Array.from(
        el.querySelectorAll('details')
      );
      if (found.length > 1) return found;
      el = el.parentElement;
      level++;
    }

    return [];
  }

  document.addEventListener(
    'click',
    function (e) {
      var summary = e.target.closest(
        'summary'
      );
      if (!summary) return;

      var detail = summary.closest('details');
      if (!detail) return;
      if (detail.classList.contains('js-filter')) return;

      var group = getGroup(detail);
      if (group.length < 2) return;

      requestAnimationFrame(function () {
        if (!detail.open) return;
        group.forEach(function (other) {
          if (other !== detail && other.open) {
            other.open = false;
          }
        });
      });
    },
    true
  );

})();
